(() => {
  const form = document.getElementById("chip-customizer-form");
  const quantity = document.getElementById("retail-quantity");
  const cartButton = document.querySelector('[data-add-to-cart="custom-poker-chips"]');
  if (!form || !quantity || !cartButton) return;
  const tiers = [
    { min: 100, max: 299, price: 1.25 },
    { min: 300, max: 499, price: 0.99 },
    { min: 500, max: 999, price: 0.95 },
    { min: 1000, max: 4999, price: 0.85 },
    { min: 5000, max: 9999, price: 0.79 },
    { min: 10000, max: 24999, price: 0.75 }
  ];
  const quoteLink = document.querySelector("[data-custom-chip-quote]");
  const tierOptions = [...document.querySelectorAll("[data-chip-variant-tiers] option")];
  const usd = amount => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(amount);
  const format = value => Number(value).toLocaleString("en-US");
  const updateTierText = (tier, unitPrice) => {
    const range = document.querySelector("[data-chip-tier-range]");
    const unit = document.querySelector("[data-chip-unit]");
    if (range) range.textContent = tier ? `${format(tier.min)}–${format(tier.max)}` : "25,000+";
    if (unit) unit.textContent = tier ? usd(unitPrice ?? tier.price) : "Contact us for a quote";
  };
  const clamp = value => Math.min(100000, Math.max(100, Math.floor(Number(value) || 100)));
  const setQty = value => { quantity.value = clamp(value); update(); };
  const update = () => {
    const qty = clamp(quantity.value);
    quantity.value = qty;
    const tier = tiers.find(item => qty >= item.min && qty <= item.max);
    const totalNode = document.querySelector("[data-chip-total]");
    const note = document.querySelector("[data-chip-order-note]");
    const material = document.getElementById("chip-material");
    const optionForTier = tier && tierOptions.find(option => option.dataset.tier === `${tier.min}-${tier.max}`);
    const unitPrice = optionForTier ? Number(optionForTier.dataset.price) : tier?.price;
    const quoteOnly = !tier || !optionForTier;
    if (tier) {
      if (optionForTier) { cartButton.dataset.variantId = optionForTier.value; cartButton.hidden = false; }
      else { delete cartButton.dataset.variantId; cartButton.hidden = true; }
      if (quoteLink) quoteLink.hidden = !quoteOnly;
      cartButton.dataset.price = unitPrice;
      if (totalNode) totalNode.textContent = usd(qty * unitPrice);
      updateTierText(tier, unitPrice);
      if (note) note.textContent = optionForTier ? "Tier variant is connected to Shopify checkout. Confirm material and artwork details before production." : "Sample prices are for layout review only. Add a Shopify product variant named for this quantity tier to enable checkout.";
    } else {
      cartButton.hidden = true;
      if (quoteLink) {
        quoteLink.hidden = false;
        const quoteUrl = new URL(window.CoolstarShopifyTheme?.routes?.pages?.wholesale || "/pages/wholesale", location.origin);
        quoteUrl.searchParams.set("set", `Custom poker chips · ${format(qty)} pieces`);
        quoteUrl.hash = "wholesale-form";
        quoteLink.href = quoteUrl.href;
      }
      if (totalNode) totalNode.textContent = "Quote required";
      updateTierText(null);
      if (note) note.textContent = "For quantities of 25,000 pieces or more, request a tailored production quote.";
    }
    const shape = form.elements.namedItem("shape")?.value === "rectangle" ? "Rectangle" : "Round";
    const style = form.elements.namedItem("artStyle")?.selectedOptions?.[0]?.textContent || "Custom";
    const tierKey = tier ? `${format(tier.min)}+ tier` : "quote tier";
    const edge = form.elements.namedItem("edgePattern")?.selectedOptions?.[0]?.textContent || "Classic stripe";
    const denomination = form.elements.namedItem("frontValue")?.value || "500";
    const outerColor = form.elements.namedItem("outerColor")?.value || "#8d263b";
    if (material) material.value = `Custom chip · ${denomination} · ${shape} · ${edge} · ${outerColor} · ${style} · ${tierKey}`;
    cartButton.classList.remove("added");
    cartButton.innerHTML = 'Add to cart <span>→</span>';
  };
  quantity.addEventListener("input", update);
  quantity.addEventListener("change", update);
  document.querySelectorAll("[data-chip-quantity]").forEach(button => button.addEventListener("click", () => setQty(clamp(quantity.value) + Number(button.dataset.chipQuantity))));
  form.addEventListener("change", event => { if (event.target.name === "shape" || event.target.name === "artStyle") update(); });
  update();
})();
